import { PayoutSource } from "./payout-source";
import { PointSeries } from "./point-series";

export class PayoutConfig {
    id: number;
    name: string;
    rodeoId: number;
    payoutFormatId: number;

    places: number;
    isAverage: boolean;
    isAggregate: boolean;
    isMoneyWon: boolean;
    includePenalties: boolean;
    uniqueRunsOnly: boolean;
    onXRounds: number;
    maxDivisions: number;
    enableManualPayouts: boolean;
    byRunIdentifier: boolean;

    divisionOffsets: any;
    divisionOffsetArray: any[] = [];
    manualPayouts: string;
    manualPayoutsArray: any[] = [];

    contestantOnePayout: boolean;
    contestantTwoPayout: boolean;

    addedMoney: number;

    expanded: boolean;

    sources: PayoutSource[];
    pointSeries: PointSeries[];

    constructor() {
        this.name = 'New Payout';
        this.places = 1;
        this.payoutFormatId = 1;
        this.uniqueRunsOnly = true;
        this.maxDivisions = 1;
        this.sources = [];
        this.divisionOffsets = "";
        this.divisionOffsetArray = [];
        this.addedMoney = 0;
        this.enableManualPayouts = false;
        this.contestantOnePayout = true;
        this.contestantTwoPayout = true;
    }
}


// WEBPACK FOOTER //
// ./src/model/payoutConfig.ts